import { render, staticRenderFns } from "./ClientesQueNaoRenovaramCard.vue?vue&type=template&id=2038c8be"
import script from "./ClientesQueNaoRenovaramCard.vue?vue&type=script&lang=ts"
export * from "./ClientesQueNaoRenovaramCard.vue?vue&type=script&lang=ts"
import style0 from "./ClientesQueNaoRenovaramCard.vue?vue&type=style&index=0&id=2038c8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports